import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import bgImage from "./bg1.jpg";
import icdLogo from "./container-corporation-of-india-logo-concor.svg";
import maskLight from "../assets/img/illustrations/auth-basic-mask-light.png";
import "../assets/vendor/css/rtl/core.css";
import "../assets/vendor/css/rtl/theme-default.css";
import "../assets/css/demo.css";
import "../assets/vendor/css/pages/page-auth.css";
import "../assets/vendor/libs/node-waves/node-waves.css";
import "../assets/vendor/libs/perfect-scrollbar/perfect-scrollbar.css";
import "../assets/vendor/libs/typeahead-js/typeahead.css";
import "../assets/vendor/libs/@form-validation/form-validation.css";
// import icdLogo from "./container-corporation-of-india-logo-concor.svg";
const ContainerFormPage = () => {
  const [formData, setFormData] = useState({ transactionType: "", crnNumber: "" });
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { transactionType, crnNumber } = formData;
    if (!transactionType || !crnNumber) return;

    setIsLoading(true);
    try {
      const endpoint =
        transactionType === "Export"
          ? `https://kycl.in/api/api/export?crnNumber=${crnNumber}`
          : `https://kycl.in/api/api/import?crnNumber=${crnNumber}`;

      const response = await axios.get(endpoint);
      console.log(response);
      if (!response.data) return;

      localStorage.setItem("searchResults", JSON.stringify(response.data));
      const dataArray = transactionType === "Export" ? response.data.gate_data : response.data.rake_in_data;
      const hasIn = Array.isArray(dataArray) && dataArray.some((item) => item.type === "IN");

      if (hasIn) {
        navigate(transactionType === "Export" ? "/Export" : "/Import", {
          state: { formData, responseData: response.data },
        });
      } else {
        console.warn("No 'IN' entries found.");
      }
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="page-bg position-relative"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
      }}
    >
      {/* Inline responsive styles */}
      <style>{`
        /* Center wrapper with responsive max width */
        .auth-center {
          max-width: 500px;
          margin: 0 auto;
          width: 100%;
          padding: 2.5rem 1rem;
        }

        /* Centered logo under title */
        .center-logo {
          text-align: center;
          margin-bottom: 0.75rem;
        }
        .center-logo img {
          max-height: 80px;
          object-fit: contain;
          display: inline-block;
        }
        .center-logo .for-icd {
          display: block;
          margin-top: 0.35rem;
          padding: 0.15rem 0.6rem;
          border-radius: 6px;
          background: #f8f9fa;
          display: inline-block;
          font-weight: 600;
          color: #c75000;
        }

        /* Card padding adjustments */
        .card.custom-card {
          padding: 1rem;
          border-radius: 12px;
          background: rgba(255,255,255,0.95);
          box-shadow: 0 6px 20px rgba(0,0,0,0.08);
        }

        /* Title responsiveness */
        .title-wrapper h1 {
          font-size: 1.75rem;
          line-height: 1.05;
        }
        .title-wrapper p {
          font-size: 0.95rem;
        }

        /* Footer tiny text */
        .footer-small small {
          font-size: 0.65rem;
        }

        /* Loader center */
        .loader {
          width: 36px;
          height: 36px;
          border: 4px solid rgba(0,0,0,0.08);
          border-top-color: #c75000;
          border-radius: 50%;
          animation: spin 0.9s linear infinite;
          margin: 0 auto 1rem auto;
        }
        @keyframes spin { to { transform: rotate(360deg); } }

        /* Copyright and love */
        .site-bottom {
          margin-top: 0.5rem;
          font-size: 0.85rem;
          color: rgba(0,0,0,0.55);
        }
        .site-love {
          font-size: 1rem;
          margin-top: 0.15rem;
        }

        /* Small devices adjustments */
        @media (max-width: 767.98px) {
          .auth-center {
            padding-top: 2.5rem;
            padding-left: 1rem;
            padding-right: 1rem;
          }
          .center-logo img {
            max-height: 60px;
          }
          .card.custom-card {
            padding: 1rem;
          }
          .title-wrapper {
            margin-bottom: 1rem;
          }
          .title-wrapper h1 {
            font-size: 1.35rem;
          }
          .title-wrapper p {
            font-size: 0.85rem;
          }
          .footer-small small {
            font-size: 0.62rem;
          }
        }

        /* Medium devices - slightly larger paddings */
        @media (min-width: 768px) and (max-width: 991.98px) {
          .auth-center { padding-top: 3.5rem; }
        }
      `}</style>

      {/* Centered auth wrapper */}
      <div className="authentication-wrapper authentication-basic container-p-y auth-center">
        <div className="authentication-inner ">
          {/* Top Center Heading */}
          <div className="text-center mb-2 title-wrapper">
            <h1 className="display-5 fw-bold mb-0 text-secondary">
              <span className="text-secondry">Customer</span>{" "}
              <span className="text-primary">Dashboard</span>
            </h1>
            <p className="lead text-muted mb-0 text-secondry" style={{ fontWeight: "inherit" }}>
              AI-Powered Real-Time Status & Tracking Dashboard
            </p>
          </div>

          {/* Centered logo below the header */}
          <div className="center-logo">
            <img src={icdLogo} alt="CONCOR logo" />
     
          </div>
 <div className="center-logo">
            {/* <img src={icdLogo} alt="CONCOR logo" /> */}
            <span className="for-icd">For ICD Tughlakabad</span>
          </div>
          <div className="card custom-card mt-4">
            <div className="card-body mt-1">
              {isLoading && <div className="loader" />}

              <form onSubmit={handleSubmit} id="formAuthentication" className="mb-4">
                <div className="form-floating form-floating-outline mb-4">
                  <select
                    name="transactionType"
                    className="form-select"
                    value={formData.transactionType}
                    onChange={handleChange}
                    required
                  >
                    <option value="" hidden>
                      Select Transaction Type
                    </option>
                    <option value="Export">Export</option>
                    <option value="Import">Import</option>
                  </select>
                  <label htmlFor="transactionType">Transaction Type</label>
                </div>

                <div className="form-floating form-floating-outline mb-4">
                  <input
                    type="text"
                    name="crnNumber"
                    className="form-control"
                    placeholder="CRN/Container Number"
                    value={formData.crnNumber}
                    onChange={(e) =>
                      handleChange({
                        target: { name: "crnNumber", value: e.target.value.toUpperCase() },
                      })
                    }
                    required
                  />
                  <label htmlFor="crnNumber">CRN/Container Number</label>
                </div>

                <button
                  type="submit"
                  className="btn d-grid w-100"
                  style={{
                    backgroundColor: "#C75000",
                    borderColor: "#C75000",
                    color: "#fff",
                  }}
                >
                  Submit
                </button>
              </form>

              {/* footer - compact */}
              <div className="divider footer-small">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="text-start">
                    <small className="text-secondary">
                      Powered by <span className="fw-bold text-primary">Sunic Technologies</span>
                    </small>
                  </div>

                  <div className="text-end">
                    <small className="text-secondary fw-bold">Beta Version</small>
                  </div>
                </div>
              </div>

              {/* Copyright and love below the card */}
          <div
  className="text-center site-bottom"
  style={{ fontSize: "0.7rem", color: "#2596be" }}
>
  Copyright © {new Date().getFullYear()} CONCOR
</div>

            </div>
          </div>

          {/* Decorative image only visible on large screens (keeps existing behaviour) */}
          <img
            src={maskLight}
            alt="triangle-bg"
            className="authentication-image d-none d-lg-block scaleX-n1-rtl"
            height="172"
          />
        </div>
      </div>
    </div>
  );
};

export default ContainerFormPage;
